import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import BranchSelectSimple from 'component/branch/BranchSelectSimple'

class VersionsView extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    user: PropTypes.object,
    data: PropTypes.object.isRequired,
    fetchDevices: PropTypes.func.isRequired,
  }

  state = {
    branchFilter: 0,
    branchArray: [],
  }

  handleChange = (event, companyOptions) => {
    const { target } = event

    const { fetchDevices } = this.props

    this.setState({ branchFilter: target.value })

    let branchArray = []

    // If less then 3 characters length, region has been selected
    if (target.value.length < 3 && companyOptions) {
      branchArray = companyOptions
        .filter((branch) => branch.idRegion === parseInt(target.value, 10))
        .map((branch) => branch.value)
    } else {
      if (target.value !== '0') {
        branchArray.push(target.value)
      }
    }

    this.setState({ branchArray })

    fetchDevices({ idBranches: branchArray })
  }

  render() {
    const { translate, user, data } = this.props

    const { branchFilter } = this.state

    return (
      <div className='padding'>
        <Row className='margin-bottom margin-top'>
          <span className='gray-title'>{translate('analytics.versions')}</span>
          <div className='margin-y-small'>
            <span className='subtitle'>
              {translate('analytics.lastVersion')} {data.versionCode}
            </span>
          </div>
        </Row>

        <Row className='margin-top'>
          <Col xs={4} xsOffset={1}>
            <span className='item-title'>{translate('analytics.updated')}</span>
          </Col>
          <Col xs={4} xsOffset={1}>
            <span className='item-title'>
              {translate('analytics.notUpdated')}
            </span>
          </Col>
        </Row>

        <Row className='margin-top'>
          <Col xs={4} xsOffset={1}>
            <span className='value'>{data.devicesUpdated}</span>
          </Col>
          <Col xs={1}>|</Col>
          <Col xs={4}>
            <span className='value'>{data.devicesNotUpdated}</span>
          </Col>
        </Row>

        <Row className='margin-top-double filters'>
          <Col xs={5} xsOffset={3}>
            <BranchSelectSimple
              name='storeWeb'
              id='storeWeb'
              user={user}
              translate={translate}
              onChange={this.handleChange}
              noValueLabel={translate('analytics.allBranches')}
              value={branchFilter}
            />
          </Col>
          <Col xs={2} xsOffset={2}>
            <div className='circular wrap-click' />
          </Col>
        </Row>
      </div>
    )
  }
}

export default VersionsView
